export default __webpack_public_path__ + "6ae7abff1b20614e4a70a75f8f64a8e8.woff2";